import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import {
  getEmailTemplates,
  insertDraftEmail
} from "../../services/adminDocuments_service";
import { useNavigate } from "react-router-dom";
import useAuthStore from "../../../../store/authStore";


const CustomDraftModal = ({
  show,
  selectedRows,
  onClose
}) => {
  const navigate = useNavigate();

  const userid = useAuthStore((state)=> state.user)

  const [templates, setTemplates] = useState([]);
  const [selectedTemplateId, setSelectedTemplateId] = useState("");
  const [previewHtml, setPreviewHtml] = useState("");

  useEffect(() => {

    if (!show) return;

    loadTemplates();

  }, [show]);

  const loadTemplates = async () => {

    try {

      const response = await getEmailTemplates();

      const filtered = response.data.filter(
        t => t.templateTypeID === 3
      );

      setTemplates(filtered);

      const defaultTemplate = filtered.find(t => t.isDefault);

      if (defaultTemplate) {

        setSelectedTemplateId(defaultTemplate.templateId);
        setPreviewHtml(defaultTemplate.emailTemplate);

      }

    }
    catch {

      toast.error("Unable to load email templates.");

    }

  };

  const handleTemplateChange = (e) => {

    const templateId = e.target.value;

    setSelectedTemplateId(templateId);

    const template = templates.find(
      t => t.templateId === parseInt(templateId)
    );

    if (template) {

      setPreviewHtml(template.emailTemplate);

    }

  };

  const handleSave = async () => {

    try {

      const docIds = selectedRows
        .map(r => r.documentId)
        .join(",");

      const alreadyEmailed = selectedRows.filter(
        x => x.emailStatus !== null && x.emailStatus !== ""
      );

      if (alreadyEmailed.length > 0) {

        toast.error(
          "Document already emailed, please review the selection"
        );

        return;

      }

      if (!selectedTemplateId || selectedTemplateId === "-1") {

        toast.error("Please select template.");

        return;

      }

      const response = await insertDraftEmail(
        docIds,
        selectedTemplateId,
        userid
      );

      const returnedEmailId = response.data;
      if (returnedEmailId === -5) {

      toast.error(
        "No recipients found. Draft not added"
      );

      return;

    }
    else if (returnedEmailId === -6){
      toast.error("No default template found. Draft not Added")
      return;
    }
      navigate('/Email', {state:{returnedEmail: returnedEmailId, selectedTab: 'draft'}})

    //   const param1 = encryptString("EmailDraftAdmin");
    //   const param2 = encryptString(returnedEmailId);

    //   let url = "/Email";

    //   if (param1 && param2) {

    //     url = `/Email?param1=${param1}&param2=${param2}`;

    //   }

    //   window.location.href = url;

    }
    catch {

      toast.error("Unable to create custom draft.");

    }

  };

  if (!show) return null;

  return (
    <>
      <div className="modal fade in" style={{ display: "block" }}>

        <div className="modal-dialog" style={{ width: "60%" }}>

          <div className="modal-content">

            <div className="modal-header" style={{ padding: "0px 0px" }}>

              <button
                className="close"
                onClick={onClose}
              >
                &times;
              </button>

              <h4 className="modal-title" style={{ margin: 0 }}>
                Custom Draft
              </h4>

            </div>

            <div
              className="modal-body"
              style={{ overflow: "auto", height: "600px" }}
            >

              <div className="row">

                <div className="col-sm-6">

                  <label>Template:</label>

                  <select
                    className="form-control"
                    value={selectedTemplateId}
                    onChange={handleTemplateChange}
                  >

                    <option value="-1">
                      -- Select --
                    </option>

                    {templates.map(t => (
                      <option
                        key={t.templateId}
                        value={t.templateId}
                      >
                        {t.templateName}
                      </option>
                    ))}

                  </select>

                </div>

              </div>

              <hr />

              <div
                dangerouslySetInnerHTML={{
                  __html: previewHtml
                }}
              />

            </div>

            <div className="modal-footer">

              <button
                className="btn btn-primary"
                onClick={handleSave}
              >
                Save
              </button>

              <button
                className="btn btn-default"
                onClick={onClose}
              >
                Cancel
              </button>

            </div>

          </div>

        </div>

      </div>
    </>
  );
};

export default CustomDraftModal;